// import React from 'react';
// import logo from './logo.png';
// import './App.css';
// import  login from './components/login';

// function App() {
//   return(
//     <div></div>
//   )
// }

// export default App;


// App.tsx

import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Login from './components/login';
import './App.css';
import Studentlists from './components/studentlist';

import Dashboard from './components/dashboard/dashboardcontent';
// import PaymentHistory from './components/dashboard/menucontent/PaymentHistory';
import Finance from './components/dashboard/menucontent/Finance';


const App: React.FC = () => {


  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/Studentlists" element={<Studentlists />} />
      <Route path="/dashboardcontent" element={<Dashboard />} />
      {/* <Route path="/paymenthistory" element={<PaymentHistory />} /> */}
      <Route path="/finance" element={<Finance />} />
    </Routes>

  );
};


export default App;
